<template>
  <v-container fluid class="policy-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Policy Information</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Policy</p>
                        <v-menu
                          ref="menu_policydate"
                          v-model="menu_policydate"
                          :close-on-content-click="false"
                          :return-value.sync="policy.policydate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="policy.policydate"
                              label="Policy Date"
                              v-bind="attrs"
                              v-bind:value="policy.policydate"
                              v-on="on"
                              single-line hint="Please choose the policy date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="policy.policydate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_policydate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_policydate.save(policy.policydate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="mb-4"
                          v-model="policy.policycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Policy Code"
                          persistent-hint
                          single-line hint="Enter the policy Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="policy.policyname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Policy Name"
                          persistent-hint
                          single-line hint="Enter the policy name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="policy.policytype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the policy type">
                        </v-select>
                          <v-switch
                            v-model="policy.policiestatus"
                            color="primary"
                            v-bind:label="policy.policiestatus"
                            value="New"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/policy/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createPolicy()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      policy: {
        policiestatus: 'New'
      },
      items: ['Welcome', 'Employment', 'Workplace Behavior', 'Recruitment', 'Health & Safety', 'Leave', 'Benefits', 'Performance', 'Employee Separation', 'Training & Development', 'Business Travel', 'Administration'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      menu_policydate: false,
    }
  },

  methods: {
    ...mapActions('Policy', ['createPolicyRequest', 'getPoliciesRequest']),
    checkError(){
      if(!this.policy.policycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.policy.policyname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.policy.policytype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    createPolicy() {
      if(!this.checkError()) return;
      this.createPolicyRequest(this.policy);
      this.getPoliciesRequest();
      router.push('/policy/list');
    },
  },
  computed: {
    ...mapState('Policy', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
